import { System } from './System'

let ids = 0

export class AvatarsSystem extends System {
  constructor(client) {
    super(client)
    this.callbacks = new Map() // id -> resolve
    this.worker = new Worker(window.AVATAR_WORKER_PATH)
    this.worker.onmessage = this.onWorkerMessage
    this.worker.onerror = this.onWorkerError
  }

  start() {
    // this.material = new AtlasMaterial({
    //   anisotropy: this.client.graphics.maxAnisotropy,
    //   skyUniforms: this.client.sky.uniforms,
    // })
  }

  setup() {
    this.rpcToWorker('init', { registry: this.client.registry.serialize() })
  }

  rpcToWorker(name, data, transfers) {
    const callbackId = ++ids
    return new Promise(resolve => {
      this.callbacks.set(callbackId, resolve)
      data.callbackId = callbackId
      this.worker.postMessage({ name, data }, transfers)
    })
  }

  onWorkerMessage = msg => {
    // console.log(`[avatars] received from worker`, msg)
    const { name, data } = msg.data
    if (name === 'callback') {
      this.callbacks.get(data.callbackId)?.(data)
      this.callbacks.delete(data.callbackId)
    }
  }

  onWorkerError = err => {
    console.error('[avatars]', err)
  }
}
